import classnames from 'classnames';
import React, { FC, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { CustomModalLayout } from '@wix/design-system';
import { HELP_LINKS } from '../../../constants/HelpLinks';
import { attachEnableDebugHandler, detachEnableDebugHandler } from '../../../services/Logger/Logger';
import { isSafari10 } from '../../../utils/userAgent';
import { useHelpLink } from '../HelpLink/useHelpModal';
import styles from './RootModal.scss';
import { IOuter } from './RootModal.types';

export const RootModal: FC<IOuter> = ({ children, onCancel }) => {
  useEffect(() => {
    attachEnableDebugHandler();

    return () => {
      detachEnableDebugHandler();
    };
  }, []);

  const { formatMessage } = useIntl();
  const { helpModalComponent, onHelpClick } = useHelpLink(HELP_LINKS.MAIN);

  return (
    <div className={classnames(styles.modal, { safari10: isSafari10(window.navigator.userAgent) })}>
      <CustomModalLayout
        title={formatMessage({ id: 'common.header' })}
        onCloseButtonClick={onCancel}
        onHelpButtonClick={onHelpClick}
        dataHook="root-modal"
        overflowY="unset"
        removeContentPadding
      >
        <div className={styles.rootLayout}>{children}</div>
      </CustomModalLayout>
      {helpModalComponent}
    </div>
  );
};
